import Box from '@eversports/klimt-primitives/legacy/Box'
import Processing from '@eversports/klimt-primitives/legacy/Processing'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { From } from '../../../../../../../App.types'
import UserInfo from '../../../../../../../components/UserInfo'
import { Localized } from '../../../../../../../localization/react'
import { PublicUser } from '../../../../../PublicUserProfile.types'

import CancelFriendRequest from './CancelFriendRequest'

interface Props {
  friend: PublicUser
}

const SentFriendRequest = ({ friend }: Props) => {
  return (
    <Processing isLoading={false}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
        <UserInfo
          profilePicture={friend.profilePicture?.small}
          firstName={friend.firstName}
          lastName={friend.lastName}
          handle={friend.handle}
          from={From.MY_SENT_FRIEND_REQUESTS}
        />
        <Stack direction="row" alignItems="center" flexShrink={0} gap={2}>
          <Box sx={{ backgroundColor: 'lightgray', borderRadius: 10, paddingY: 1, paddingX: 3 }}>
            <Text variant="xsmall" sx={{ color: 'midnight' }}>
              <Localized id="friend-request-badge" />
            </Text>
          </Box>
          <CancelFriendRequest friendId={friend.id} />
        </Stack>
      </Stack>
    </Processing>
  )
}

export default SentFriendRequest
